<script>
  import TemplateLogin from './templates/TemplateLogin.vue'
  import Sidebar from './components/Sidebar.vue'
  import Header from './components/Header.vue'
  import Main from './components/Main.vue'
  import Footer from './components/Footer.vue'
  import MainAuth from './components/MainAuth.vue'
  import Login from './page/Login/Login.vue'

  import axios from 'axios'

  export default {
    data() {
      return {
        d: '',
        loading: true,
        params: {},
      }
    },
    components: {
      TemplateLogin,
      Sidebar,
      Header,
      Main,
      Footer,
      MainAuth,
      Login,
    },
    mounted() {
      this.params = window
        .location
        .search
        .replace('?', '')
        .split('&')
        .reduce(
          function (p, e) {
            var a = e.split('=');
            p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
            return p;
          },
          {}
        );
      axios({
        method: 'get',
        url: `/tourclient/account/currentUser?_=${new Date().getTime()}`,
        requestId: 'AccountUserCurrent'
      }).then(
        ({data}) => {
          this.loading = false;
          this.$root.auth = data.IsAuthenticated;
        },
        err => {
          this.loading = false;
          MAG.app.$notify.error({
            title: 'Ошибка',
            message: 'В данный момент ведутся работы, попробуйте войти немного позже'
          });
        }
      )
    },
  }
</script>
<template>
  <TemplateLogin>
    <!--<Login></Login>-->
    <Main v-if="!loading&&!$root.auth" @auth="$root.auth=$event" :params="params"/>
    <MainAuth v-if="!loading&&$root.auth" @auth="$root.auth=$event" :params="params"/>
  </TemplateLogin>
</template>

